export const timeFormat: string = 'hh:mm a';
